"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFitTestDto = instanceOfFitTestDto;
exports.FitTestDtoFromJSON = FitTestDtoFromJSON;
exports.FitTestDtoFromJSONTyped = FitTestDtoFromJSONTyped;
exports.FitTestDtoToJSON = FitTestDtoToJSON;
exports.FitTestDtoToJSONTyped = FitTestDtoToJSONTyped;
const FileDto_1 = require("./FileDto");
const MaskType_1 = require("./MaskType");
/**
 * Check if a given object implements the FitTestDto interface.
 */
function instanceOfFitTestDto(value) {
    if (!('maskType' in value) || value['maskType'] === undefined)
        return false;
    if (!('otherDescription' in value) || value['otherDescription'] === undefined)
        return false;
    if (!('testDate' in value) || value['testDate'] === undefined)
        return false;
    return true;
}
function FitTestDtoFromJSON(json) {
    return FitTestDtoFromJSONTyped(json, false);
}
function FitTestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'maskType': (0, MaskType_1.MaskTypeFromJSON)(json['maskType']),
        'otherDescription': json['otherDescription'],
        'testDate': (new Date(json['testDate'])),
        'documentationUrl': json['documentationUrl'] == null ? undefined : json['documentationUrl'],
        'documentation': json['documentation'] == null ? undefined : (0, FileDto_1.FileDtoFromJSON)(json['documentation']),
    };
}
function FitTestDtoToJSON(json) {
    return FitTestDtoToJSONTyped(json, false);
}
function FitTestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'maskType': (0, MaskType_1.MaskTypeToJSON)(value['maskType']),
        'otherDescription': value['otherDescription'],
        'testDate': ((value['testDate']).toISOString()),
        'documentationUrl': value['documentationUrl'],
        'documentation': (0, FileDto_1.FileDtoToJSON)(value['documentation']),
    };
}
//# sourceMappingURL=FitTestDto.js.map